/*
 * ******************************************************************
 * Copyright (c) 2022-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { ClosableDialog } from "./closable-dialog";

@Directive()
export abstract class BaseDialog extends ClosableDialog {

    public opened: boolean;
    @Input() escEnabled: boolean = true;
    @Output() confirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

    public showDialog(): void {
        this.opened = true;
    }

    public closeDialog(confirmed: boolean): void {
        this.confirmed.emit(confirmed);
        this.opened = false;
        super.close();
    }

    public handleEsc(): void {
        if (this.escEnabled) {
            this.closeDialog(false);
        }
    }
}
